
import Vue from "vue";
import ProgressBar from "@/components/common/ProgressBar.vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import { IBreadCrumbRoute } from "@/types/index";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import ContactTemplate from "@/components/common/ContactTemplate.vue";

export default Vue.extend({
  name: "contact",
  components: {
    HeroBanner,
    BreadCrumb,
    ProgressBar,
    ContactTemplate,
  },
  mixins: [UIFeatureMixin],
  data() {
    return {
      routes: [
        { to: { name: "home" }, text: "Home" },
        { to: { name: "contact" }, text: "Contact Us" },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    let uiFeatureArray =
      "HME_THIS,NCOUNTY_1,NCOUNTY_2,NCOUNTY_3,AVAIL_CNTY,AVL_COUNTY,QUICK_SRCH,ER_INLINE,CHGLGN_TXT,ADMN_USR,MAIN,MAIN_TITLE,FMR,ENVRONMNT,ADA,FTP,MATP,PWD,SSR,CNTCT_US,CNT_US_C,SEL_CNTY,FLT_CNTIES,SEL_ALLCNT";

    store.dispatch.uiFeatureModule.getUIFeatures(uiFeatureArray);
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
